export default {
  init() {
    // JavaScript to be fired on the home page

    //$('h1').lettering('words');
    $('.section-showcase h2').lettering('words');

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js